import React, {Component} from 'react';
import logoBlack from '../assets/images/logo-black.png';
import BusinessSignUpForm from "../parts/BusinessSignUpForm";
import config, {AIRTABLE_HOOKS_ROOT, API_ROOT} from "../config";
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaTitles, title} from "../website-utils/meta";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";
import BusinessTrialForm from "../parts/BusinessTrialForm";
import {connect} from "react-redux";
import {loginSuccess} from "../state/actions/auth";
import qs from 'qs';
import {SubmissionError} from "redux-form";
import {createManager, receiveManagers} from "../state/actions/managers";
import {fetchBusinessById, receiveBusiness} from "../state/actions/business";
import BusinessHeaderBare from "../parts/BusinessHeaderBare";
import {fetchUser} from "../state/actions/user";


class BusinessSignUpPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signupSuccess: false,
      email: null,
    }
  }

  componentDidMount() {
    window.analytics.page("Business", "Sign Up");
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.managers && this.props.managers) {
      const manager = this.props.managers[0];

      this.setState({
        signupSuccess: true,
      });
      window.analytics.track("Business Sign Up - Completed");
      window.analytics.identify(manager.id, {
        id: manager.id,
        "name": manager.name,
        "email": manager.user.email,
        "phone": manager.phone_number,
      });
      window.FS && window.FS.identify(manager.id, {
        displayName: manager.name,
        email: manager.user.email,
        phone: manager.phone_number,
      });

      this.completed();
    }
  }

  createBusiness = ({name, address}, values) => {
    // This should be in Redux but we're putting it here for convenience
    return fetch(API_ROOT + '/businesses/', {
      method: 'POST',
      headers: {
        'Content-Type':
          'application/json'
      },
      body: JSON.stringify({
        name: name,
        address: address,
      }),
    }).then(response => {
      if (response.status === 201) {
        return response.json().then(business => {
          this.props.receiveBusiness(business);
          this.setState({
            business: business,
          });

          if (values) {
            fetch(AIRTABLE_HOOKS_ROOT + '/business/', {
              method: 'POST',
              body: JSON.stringify({slug: business.slug, ...values}),
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(response => console.log(response), error => console.error(error));
          }

          return business;
        });
      }
    })
  };

  handleSubmit = (values, dispatch) => {
    // This function is a mess. We should probably move it to redux at some point
    this.setState({
      email: values.email
    });

    // Create auth user first
    return fetch(API_ROOT + '/rest-auth/registration/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: values.email,
        password1: values.password,
        password2: values.password,
      })
    }).then(response => {
      return response.json().then(json => {
        if (response.status === 201) {
          // User created
          this.props.loginSuccess(json.key);
          this.props.fetchUser();
        } else {
          if (json.email) {
            throw new SubmissionError({
              email: json.email[0],
              _error: 'Sign Up Failed!',
            });
          }
          throw new SubmissionError({
            _error: 'Sign Up Failed!',
          })
        }
      });
    }, error => {
      console.error(error);
    }).then(() => {
      // Then, create a business
      this.createBusiness({name: values.businessName, address: values.businessAddress}, values).then(business => {
        // Create a manager
        this.props.createManager({
          name: values.name,
          phone: values.countryCode + values.phoneNumber
        });
      });
    });
  };

  completed = () => {
    this.props.history.push('/' + this.props.business.slug);
  };

  render() {
    window.prerenderReady = true;

    return (
      <div className="business registration">
        <Helmet>
          {title('SingleShift - Business Sign Up')}
          {metaTitles('SingleShift - Business Sign Up')}
          {metaDescriptions('We help restaurants and caterers fill staffing gaps with our marketplace of vetted and experienced culinary professionals.')}
        </Helmet>
        <ScrollToTopOnMount/>
        <div className="container">
          <BusinessHeaderBare/>

          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-6">
              <h2>Create Your Account</h2>
            </div>
          </div>

          <div className="singleshift-form">
            <BusinessSignUpForm onSubmit={this.handleSubmit}/>
          </div>

          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-6 account-nav text-center">
              <small>Already have an account? <Link to={config.routes.businessLogin}>Log in</Link></small>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({
  business: state.business.item,
  managers: state.managers.items,
}), (dispatch) => ({
  receiveBusiness: (business) => dispatch(receiveBusiness(business)),
  fetchBusinessById: (id) => dispatch(fetchBusinessById(id)),
  loginSuccess: (token) => dispatch(loginSuccess(token)),
  createManager: (managerInfo) => dispatch(createManager(managerInfo)),
  fetchUser: () => dispatch(fetchUser()),
}))(BusinessSignUpPage);



// WEBPACK FOOTER //
// ./src/pages/BusinessSignUpPage.js